module.exports = __webpack_public_path__ + "static/media/stekker.fdf36785.png";